// Regex to add a dot mask to hscode
export const formatHSCode = (hsCode: string): string => {
  if (hsCode.length <= 4) {
    return hsCode;
  }
  if (hsCode.length <= 6) {
    return hsCode.replace(/(\d{4})(\d{2})?/, "$1.$2");
  }

  return hsCode.replace(/(\d{4})(\d{2})(\d{4})/, "$1.$2.$3");
};

// Regex to remove any character that is not a digit
export const removeAllCharactersAndSymbols = (inputString: string): string => {
  return inputString.replace(/[^\d]/g, "");
};

// Returns the substring with the last 4 digits from a commodity code
export const formatCommodityCode = (hsCode: string): string => {
  return hsCode.substr(6, 4);
};

export const REGEX_TEST_8_TO_10_DIGITS = /^.{8,10}$/;
export const REGEX_TEST_NUMERIC = /^[0-9]+$/;

export enum CodeType {
  CHAPTER = "Chapter (HS code)",
  HEADING = "Heading (HS code)",
  HS_CODE = "HS code",
  COMMODITY_CODE = "Commodity Code",
}

export const CodeTypeNumber = {
  [CodeType.CHAPTER]: 2,
  [CodeType.HEADING]: 4,
  [CodeType.HS_CODE]: 6,
  [CodeType.COMMODITY_CODE]: 10,
};

export const CodeLevelType: { [x: string]: string } = {
  2: CodeType.CHAPTER,
  4: CodeType.HEADING,
  6: CodeType.HS_CODE,
  10: CodeType.COMMODITY_CODE,
};

export const getHSCode = (commodityCode: string): string => {
  return commodityCode.substring(0, 6);
};
